module.exports = __webpack_public_path__ + "static/media/specialFood.08127133.png";